import React, { useState, useEffect } from "react";
import { tenantAPI } from "../../services/api/tenant";
import { getCookie } from "../../utils/common";

const FreshWorks = () => {
  const [widgetId, setWidgetId] = useState(null);
  const tenantUuid = getCookie("current_tenant_uuid");

  useEffect(() => {
    if (tenantUuid) {
      getTenant(tenantUuid);
    }
  }, [tenantUuid]);

  const getTenant = (tenantUuid: string) => {
    tenantAPI?.()
      .getSingle?.(tenantUuid)
      .then((resp) => {
        if (resp.fresh_works_widget_id) {
          setWidgetId(resp.fresh_works_widget_id);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    if (widgetId) {
      const settingsScript = document.createElement("script");
      settingsScript.innerHTML = `
      window.fwSettings = {
        'widget_id': ${widgetId}
      };
      (function() {
        if (typeof window.FreshworksWidget !== 'function') {
          var n = function() { n.q.push(arguments) };
          n.q = [];
          window.FreshworksWidget = n;
        }
      })();
    `;

      document.head.appendChild(settingsScript);

      const widgetScript = document.createElement("script");
      widgetScript.src = `https://widget.freshworks.com/widgets/${widgetId}.js`;
      widgetScript.type = "text/javascript";
      widgetScript.async = true;
      widgetScript.defer = true;

      document.head.appendChild(widgetScript);
    }
  }, [widgetId]);

  return <></>;
};

export default FreshWorks;
